import PageHero from "../components/PageHero";
import InfoCard from "../components/InfoCard";
import SectionIntro from "../components/SectionIntro";
import Button from "../components/Button";
import { consultingServices, consultingSupport, homeImages } from "../data/siteData";

export default function ScientificConsultingPage() {
  return (
    <>
      <PageHero
        eyebrow="Scientific & Research Consulting"
        title="Turning scientific ideas into fundable, actionable programs."
        description="BrainTorch™ Bio provides scientific consulting services that help organizations strengthen research programs, develop competitive proposals, and translate complex science into clear, actionable strategies."
        image={homeImages.services}
      />

      <section className="section shell">
        <SectionIntro
          eyebrow="Our Consulting Services"
          title="Strategy, writing, and program development for research and education."
          text="Support across the full lifecycle of research, education, and workforce initiatives — from concept through implementation and evaluation."
          align="center"
        />
        <div className="card-grid card-grid--four top-gap-lg">
          {consultingServices.map((service) => (
            <InfoCard key={service.title} title={service.title} text={service.description} icon={service.icon} />
          ))}
        </div>
      </section>

      <section className="section shell section--tight-top">
        <SectionIntro
          eyebrow="Consulting Support Tiers"
          title="Choose the right level of support."
          text="From starter engagements to full workforce program design, these tiers help organizations select the right scope for their research, education, or workforce initiative."
          align="center"
        />
        <div className="card-grid card-grid--three top-gap-lg">
          {consultingSupport.map((item) => (
            <InfoCard key={item.title} title={item.title} text={item.summary} />
          ))}
        </div>
      </section>

      <section className="section shell section--tight-top">
        <div className="cta-band">
          <div>
            <h2>Ready to strengthen your next research, education, or workforce initiative?</h2>
            <p>Schedule a consultation to explore how BrainTorch™ Bio can support your organization’s scientific and program development goals.</p>
          </div>
          <div className="button-row">
            <Button to="/contact#contact-connect" variant="teal">Schedule a Consultation</Button>
          </div>
        </div>
      </section>
    </>
  );
}
